import coronaCrash from './coronaCrash';
import moneyFactory from './moneyFactory';
import giftCard from './giftCard';
import brilliantProspects from './brilliantProspects';
import inflation from './inflation';
import generationY from './generationY';
import banksFalter from './banksFalter';
import currencies from './currencies';
import bitcoinCrypto from './bitcoinCrypto';
import lookForHealth from './lookForHealth';
import lookForHealthFlipBook from './lookForHealthFlipBook';
import moneyCombo1 from './moneyCombo1';
import moneyCombo2 from './moneyCombo2';
import moneyCombo3 from './moneyCombo3';
import switzerlandCaresFor from './switzerlandCaresFor';
import searchForWealth from './searchForWealth';
import suddenMoney from './suddenMoney';
import bullsBearsBeginners from './bullsBearsBeginners';
import howToInvestMoney from './howToInvestMoney';
import howToInvestMoneyFrench from './howToInvestMoneyFrench';
import howToInvestBonds from './howToInvestBonds';
import introductionFinancialMathematics from './introductionFinancialMathematics';
import introductionFinancialMathematicsEnglish from './introductionFinancialMathematicsEnglish';

import {
  CORONA_CRASH,
  MONEY_FACTORY,
  GIFT_CARD,
  BRILLIANT_PROSPECTS,
  INFLATION,
  GENERATION_Y,
  BANKS_FALTER,
  CURRENCIES,
  BITCOIN_CRYPTO,
  LOOK_FOR_HEALTH,
  LOOK_FOR_HEALTH_FLIP_BOOK,
  MONEY_COMBO_1,
  MONEY_COMBO_2,
  MONEY_COMBO_3,
  SWITZERLAND_CARES_FOR,
  SEARCH_FOR_WEALTH,
  SUDDEN_MONEY,
  BULLS_BEARS_BEGINNERS,
  HOW_TO_INVEST_MONEY,
  HOW_TO_INVEST_MONEY_FRENCH,
  HOW_TO_INVEST_BONDS,
  INTRODUCTION_FINANCIAL_MATHEMATICS,
  INTRODUCTION_FINANCIAL_MATHEMATICS_ENGLISH,
} from '../const';

export default {
  [CORONA_CRASH]: coronaCrash,
  [MONEY_FACTORY]: moneyFactory,
  [GIFT_CARD]: giftCard,
  [BRILLIANT_PROSPECTS]: brilliantProspects,
  [INFLATION]: inflation,
  [GENERATION_Y]: generationY,
  [BANKS_FALTER]: banksFalter,
  [CURRENCIES]: currencies,
  [BITCOIN_CRYPTO]: bitcoinCrypto,
  [LOOK_FOR_HEALTH]: lookForHealth,
  [LOOK_FOR_HEALTH_FLIP_BOOK]: lookForHealthFlipBook,
  [MONEY_COMBO_1]: moneyCombo1,
  [MONEY_COMBO_2]: moneyCombo2,
  [MONEY_COMBO_3]: moneyCombo3,
  [SWITZERLAND_CARES_FOR]: switzerlandCaresFor,
  [SEARCH_FOR_WEALTH]: searchForWealth,
  [SUDDEN_MONEY]: suddenMoney,
  [BULLS_BEARS_BEGINNERS]: bullsBearsBeginners,
  [HOW_TO_INVEST_MONEY]: howToInvestMoney,
  [HOW_TO_INVEST_MONEY_FRENCH]: howToInvestMoneyFrench,
  [HOW_TO_INVEST_BONDS]: howToInvestBonds,
  [INTRODUCTION_FINANCIAL_MATHEMATICS]: introductionFinancialMathematics,
  [INTRODUCTION_FINANCIAL_MATHEMATICS_ENGLISH]: introductionFinancialMathematicsEnglish,
};
